'use client';

import styles from './note-content.module.css';
import { useState } from 'react';
import { Dialog, Portal, VisuallyHidden } from '@radix-ui/themes';
import MarkdownExtended from '../../markdown/markdown-extended';
import ClientThemeProvider from '../../providers/client-theme-provider';

interface Props {
  markdown: string;
}

export default function NoteContent({ markdown }: Props) {
  const [modalOpen, setModalOpen] = useState(false);

  return (
    <>
      <Dialog.Root
        open={modalOpen}
        onOpenChange={setModalOpen}
      >
        <Dialog.Trigger>
          <div className={styles.OpenNoteTrigger}>
            <div className={styles.QuestionMark}>?</div>
          </div>
        </Dialog.Trigger>
        <Portal>
          <ClientThemeProvider>
            <Dialog.Content
              maxWidth='80vw'
              style={{ position: 'relative' }}
            >
              <VisuallyHidden asChild>
                <Dialog.Title>Заметки</Dialog.Title>
              </VisuallyHidden>
              <MarkdownExtended
                markdown={markdown}
                lightboxPortalId='image-lightbox-portal-note'
              />
              <div id='image-lightbox-portal-note' />
            </Dialog.Content>
          </ClientThemeProvider>
        </Portal>
      </Dialog.Root>
    </>
  );
}
